import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { HighLoadPermitsPage, HighLoadPermitsPageProps } from "./HighLoadPermitsPage";

export const EMPTY_PAGE_CONTENT: HighLoadPermitsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/high-load-permit";

export const HighLoadPermitsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<HighLoadPermitsPageProps>("high_load_consents", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <HighLoadPermitsPage {...routeProps} {...content} />;
};
